import { getCurrency } from '@common/utils/currency'

import { SettingsOption } from '@/modules/creator-settings/ui/SettingsOption.tsx'

interface ProfitViewProps {
  profit: number | undefined
  showCents?: boolean
}

export const ProfitView = ({ profit, showCents }: ProfitViewProps) => {
  return (
    <SettingsOption
      title="Profit"
      description="The financial surplus or gain obtained when your earnings exceed your expenses"
      mobileVertical
      biggerTitle
    >
      <h3 className="text-2xl font-semibold">
        {profit ? getCurrency(profit, showCents ? 2 : 0) : 'No Data'}
      </h3>
    </SettingsOption>
  )
}
